import { FC, ReactNode } from 'react';

import { Text, VStack } from '@bonusly/design-system';

import type { Reward } from '../../../schemas/rewards';
import { RewardsHighlightsCard } from './rewards-highlights-card';

export interface RewardsHighlightsSectionProps {
	title: string;
	rewards: Reward[];
	onRewardClick: (rewardId: string) => void;
	emptyState?: ReactNode;
}

export const RewardsHighlightsSection: FC<RewardsHighlightsSectionProps> = ({ title, rewards, onRewardClick, emptyState }) => {
	return (
		<VStack spacing={2} align="stretch" w="full" px={1}>
			<Text fontSize="16px" fontWeight="600" lineHeight="24px" letterSpacing="-0.208px" color="text.primary" h="24px">
				{title}
			</Text>
			{rewards.length === 0 && emptyState ? (
				emptyState
			) : (
				<VStack spacing={0} align="stretch">
					{rewards.map((reward) => (
						<RewardsHighlightsCard key={reward.id} reward={reward} onClick={() => onRewardClick(reward.id)} />
					))}
				</VStack>
			)}
		</VStack>
	);
};
